import { NgSubmitDirective } from './ng-submit.directive';

const ngModule = angular.module('bb.ng-submit', []);

ngModule.directive('ngSubmit', NgSubmitDirective);

export default ngModule;
